import { render, staticRenderFns } from "./IconPlaylistAdd.vue?vue&type=template&id=0879b5ce&"
import script from "./IconPlaylistAdd.vue?vue&type=script&lang=js&"
export * from "./IconPlaylistAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0879b5ce')) {
      api.createRecord('0879b5ce', component.options)
    } else {
      api.reload('0879b5ce', component.options)
    }
    module.hot.accept("./IconPlaylistAdd.vue?vue&type=template&id=0879b5ce&", function () {
      api.rerender('0879b5ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPlaylistAdd.vue"
export default component.exports